module.exports = __webpack_public_path__ + "static/media/shaff1199.2ee56ccd.jpg";